export const RestrictionsColorMapper = (status) => ({
  CREATED: 'default',
  PENDING: 'info',
  RESOLVED: 'success',
  FORCED: 'warning',
  DELETED: 'info',
  EXPIRED: 'warning',
  PENDINGREVIEW: 'info',
  ACCEPTED: 'success',
  REJECTED: 'error',
  NOTREQUIRED: 'default',
}[status]);

export const CONTRACT_TYPE_TO_SPANISH = {
  NOTARY: 'Notarial',
  DIGITAL: 'Digital',
};
